// This file is generated by scripts/generate-build-info.js.
const buildInfo = {
  "name": "Alfin Contacto",
  "version": "1.1.0",
  "buildDate": "2026-07-27T20:53:57.277Z"
};

export default buildInfo;
